import React from 'react';
import { Flex } from '../Flex';
import { Typography } from '../Typography';

// Natural time format = server can return it on this format
export type ArticleAdviceQuestionValue = {
  text: string;
  dateLabel?: string;
  userLabel?: string;
};
type Props = {
  value: ArticleAdviceQuestionValue;
};
export const ArticleAdviceQuestion = ({
  value: {
    text,
    dateLabel
  }
}: Props) => <>
    <Typography variant="body2" display="block" style={{
    wordWrap: 'break-word'
  }} mb={['16px', '20px']} lineHeight="1.5" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
      {text}
    </Typography>

    <Flex justifyContent="space-between" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
      <Typography fontSize="14px" opacity={0.5} m={0} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
        {dateLabel}
      </Typography>
    </Flex>
  </>;
export type ArticleAdviceQuestionProps = Props;